var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"questionnaire-page"}},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],attrs:{"id":"innerPage","src":_vm.outPath,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }